export function Test1() {
    console.log("Test1 Component Rendered");

    return (
        <div>
            <h1>Test1</h1>
        </div>
    );
}
